import * as R from 'remeda';
import { Queue } from '@rossum/api-client/queues';
import { User } from '@rossum/api-client/users';

export const getActiveUserPage = (pathname: string) =>
  (['access', 'info'] as const).find(page => pathname.includes(page));

export const getUserName = (user: User): string => {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user.email) {
    return user.email;
  }

  return user.username;
};

export const getQueueAndWorkspacesCounts = (
  user: User,
  queues: Queue[],
  isAdmin: boolean
) => {
  const userQueues = isAdmin
    ? queues
    : R.pipe(
        queues,
        R.filter(queue => user.queues.includes(queue.url))
      );

  const userWorkspaces = R.pipe(
    userQueues,
    R.map(queue => queue.workspace),
    R.unique()
  );

  return {
    queuesCount: userQueues.length,
    workspacesCount: userWorkspaces.length,
  } as const;
};
